const LOAD_DATA_MASTER_SKILLS         = 'LOAD_DATA_MASTER_SKILLS'
const LOAD_DATA_MASTER_SKILLS_SUCCESS = 'LOAD_DATA_MASTER_SKILLS_SUCCESS'
const LOAD_DATA_MASTER_SKILLS_FAILED  = 'LOAD_DATA_MASTER_SKILLS_FAILED'
const UNMOUNT_DATA_MASTER_SKILLS      = 'UNMOUNT_DATA_MASTER_SKILLS'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const skillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_SKILLS:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_SKILLS_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_SKILLS_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_SKILLS:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default skillsReducer